// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1id4J","right":"styles_right__TXAnj"};